import { HttpService } from "../HttpService";

/**
 * Get first future date with timeslot.
 * @returns {Promise<string>}
 */
export async function getTimeslotFirstDay(
  eventId: string,
  categoryIds: string[] = [],
  future: boolean,
) {
  const params = [`categories=${categoryIds.join(",")}`];
  if (future) {
    params.push("future=1");
  }
  const response = await HttpService.get(
    `${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/timeslot/first-day?${params.join("&")}`,
  );
  return response.data;
}

/**
 * Get first future date with timeslot.
 * @returns {Promise<string>}
 */
export async function getTimeslotFirstDoctorDay(
  eventIds: string[] = [],
  onlyAssigned: boolean,
) {
  const params = eventIds.map((eventId) => `eventIds[]=${eventId}`);
  if (onlyAssigned) {
    params.push("onlyAssigned=true");
  }
  const response = await HttpService.get(
    `${process.env.REACT_APP_API}/t4event/api/v01/federfarma/doctor/timeslot/first-day?${params.join('&')}`,
  );
  return response.data;
}
